module.exports = __webpack_public_path__ + "static/media/home-grid-item-2.1b02329d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/home-grid-item-2.png
// module id = 511
// module chunks = 0